export function InputBadge({ value }: { value: string }) {
  return (
    <div className="bg-grey-40 text-grey-60 flex h-10 min-w-10 items-center justify-center rounded-lg text-2xl font-semibold">
      {value}
    </div>
  );
}
